import { createPromotionsListInteractor } from '../../../promotions/app/components/fym-promotions/interactor';
import { selectors } from '../../../../../state';

export function initializePromotionsComponent(
  updStore,
  source,
  scope,
  promotionType
) {
  const promotions = selectors.promotions.getPromotions(updStore.getState());
  const interactor = createPromotionsListInteractor({
    source,
    updStore: updStore,
    placement: 'forward_mail',
    promotions,
    promotionType,
  });
  const updateState = () => {
    const state = updStore.getState();

    if (source === 'fym_details' || source === 'confirmation') {
      interactor.setHidden(false);
    } else {
      interactor.setHidden(true);
    }

    const promotions = selectors.promotions.getPromotions(state);
    interactor.setPromotions(promotions);
  };
  const unsub = updStore.subscribe(updateState);
  scope.$on('$destroy', unsub);
  return interactor;
}
